<template>
  <base-section id="theme-features"> </base-section>
</template>

<script>
export default {};
</script>
